import axios from 'axios';
import jwtInterceptor from './jwtInterceptor';
import errorInterceptor from './errorInterceptor';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_STATS_BACKEND_BASE_URI}/api/mcp-api-keys`,
  headers: {
    "Content-Type": "application/json"
  }
});
instance.interceptors.request.use(jwtInterceptor);
instance.interceptors.response.use(undefined, errorInterceptor);

export interface McpApiKey {
  id: number;
  name: string;
  client_type: string;
  host_metadata: Record<string, unknown> | null;
  scopes: string[];
  created_at: string | null;
  last_seen_at: string | null;
  revoked_at: string | null;
  expires_at: string | null;
}

export interface GenerateMcpApiKeyPayload {
  name: string;
  scopes?: string[];
}

export interface GeneratedMcpApiKey {
  id: number;
  name: string;
  token: string;
  prefix: string;
  scopes: string[];
  created_at: string | null;
  warning: string;
}

export const generateMcpApiKey = (
  name: string,
  scopes: string[] = ["read", "write"]
): Promise<GeneratedMcpApiKey> =>
  instance.post<GeneratedMcpApiKey>("", { name, scopes }).then((r) => r.data);

export const listMcpApiKeys = (
  includeRevoked = false
): Promise<McpApiKey[]> =>
  instance
    .get<{ data: McpApiKey[] }>("", { params: { include_revoked: includeRevoked } })
    .then((r) => r.data.data);

export const revokeMcpApiKey = (id: number): Promise<void> =>
  instance.delete(`/${id}`).then(() => undefined);

export const getMcpApiKey = (id: number): Promise<McpApiKey> =>
  instance.get<McpApiKey>(`/${id}`).then((r) => r.data);

export default instance;
